import React, { useEffect, useMemo, useState } from 'react';
import { Result, Tabs, theme } from 'antd';
import { SettingOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';

import PrinterSettings from '../CategoryManagement/printerCategories/components/PrinterSettings';
import { categoryPermissions } from '../../utils/permissions';

const { TabPane } = Tabs;

const SystemCategories = () => {
    const { user } = useSelector(state => state.auth);

    const [activeKey, setActiveKey] = useState('printer-categories');
    const {
        token: { borderRadiusLG },
    } = theme.useToken();

    const canViewCategories = categoryPermissions.canRead(user);
    const canManagePrinterCategories = categoryPermissions.canManagePrinterCategories(user);

    const allTabs = [
        {
            key: 'printer-categories',
            tab: <span><SettingOutlined /> Printer Categories</span>,
            component: <PrinterSettings user={user} />,
            permission: canManagePrinterCategories
        },
    ];

    const availableTabs = useMemo(() => allTabs.filter(tab => tab.permission), [canManagePrinterCategories]);

    const defaultActiveKey = useMemo(() => {
        if (availableTabs.length > 0) {
            if (!availableTabs.find(tab => tab.key === activeKey)) {
                return availableTabs[0].key;
            }
        }
        return activeKey;
    }, [availableTabs, activeKey]);

    useEffect(() => {
        if (defaultActiveKey !== activeKey) {
            setActiveKey(defaultActiveKey);
        }
    }, [defaultActiveKey, activeKey]);

    if (!canViewCategories) {
        return (
            <div style={{ margin: '24px 16px' }}>
                <Result
                    status="403"
                    title="403"
                    subTitle="Sorry, you don't have access to system categories."
                />
            </div>
        );
    }

    if (availableTabs.length === 0) {
        return (
            <div style={{ margin: '24px 16px' }}>
                <Result
                    status="warning"
                    title="Limited access"
                    subTitle="You can view categories but don't have permission to manage any system category tabs."
                />
            </div>
        );
    }

    return (
        <div
            style={{
                margin: '24px 16px',
                borderRadius: borderRadiusLG,
                minHeight: 280,
            }}
        >
            <Tabs
                activeKey={activeKey}
                onChange={setActiveKey}
                type="card"
                tabBarGutter={5}
                className="category-management-tabs"
            >
                {availableTabs.map(tab => (
                    <TabPane
                        tab={tab.tab}
                        key={tab.key}
                    >
                        {tab.component}
                    </TabPane>
                ))}
            </Tabs>
        </div>
    );
};

export default SystemCategories;
